angular.module('app').controller('ViewApiDocumentModalCtrl',
    ['$scope', '$uibModalInstance', 'modalConfig',
        function ($scope, $modalInstance, modalConfig) {
            'use strict';

            $scope.downloadingDocument = false;
            $scope.model = {
                Title: modalConfig.Title,
                EnableDownload: !!modalConfig.DocumentDownload,
                DownloadFileName: modalConfig.DownloadFileName,
                DocumentId: modalConfig.DocumentId,
                HasStaticUrl: modalConfig.HasStaticUrl,
                DisableInlinePdf: modalConfig.DisableInlinePdf,
                DocumentHelper: modalConfig.DocumentHelper,
                ClientID: modalConfig.ClientID,
                ClientURL: modalConfig.ClientURL,
            };

            function getStaticUrl(documentId) {
                return modalConfig.GetStaticUrl(documentId);
            }

            function loadDocument(documentId, requestSettings) {
                $scope.loadingDocument = true;
                return modalConfig.DocumentLoad(documentId, requestSettings)
                    .finally(function () {
                        $scope.loadingDocument = false;
                    });
            }

            function downloadDocument(documentId) {
                $scope.downloadingDocument = true;
                return modalConfig.DocumentDownload(documentId)
                    .finally(function () {
                        $scope.downloadingDocument = false;
                    });
            }

            function ok() {
                $modalInstance.close('ok');
            }

            function cancel() {
                $modalInstance.dismiss('cancel');
            }

            $scope.ok = ok;
            $scope.cancel = cancel;
            $scope.getStaticUrl = getStaticUrl;
            $scope.loadDocument = loadDocument;
            $scope.downloadDocument = downloadDocument;
        }]);
